import type { Route } from '~/core/router'

import * as root from '~/routes/movies/root'

export const route: Route = {
  children: [
    {
      path: '',
      component: [root.Title, root.MoviesPage],
      init: root.model.init,
      left: root.model.left,
    },
  ],
}
